import { makeStyles } from '@material-ui/core';
import React, { useState, useCallback } from 'react';
import { Create } from 'react-admin';
import { FormSpy } from 'react-final-form';
import omit from 'lodash/omit';

import CreateToolbar from '../../core/components/CreateToolbar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import FormTitleBar from '../../core/components/FormTitleBar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import CategoryTermsSummary from './CategoryTermsSummary';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const useStyles = makeStyles({
  noActions: {
    marginTop: '0px'
  }
});

const CategoryTermTitle = ({ record }) => {
  return (
    <FormTitleBar
      creation={true}
      showAvatar
      avatarContent={'CT'}
      recordLabel="Terms And Conditions"
    />
  );
};

const CategoryTermsCreate = props => {
  const classes = useStyles();
  const [whenBlockNavigation, setWhenBlockNavigation] = useState(false);

  const handleFormIsDirty = useCallback(
    dirty => {
      // Block navigation when the form is dirty
      setWhenBlockNavigation(dirty);
    },
    [setWhenBlockNavigation]
  );

  const allowNavigationOnSave = () => {
    setWhenBlockNavigation(false);
  };

  return (
    <React.Fragment>
      <NavigationPrompt when={whenBlockNavigation} creation {...props}>
        {(isOpen, onConfirm, onCancel) => (
          <LeaveConfirm
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onCancel}
          />
        )}
      </NavigationPrompt>
      <Create
        {...omit(props, [
          'userProfile',
          'hasDeletePermission',
          'hasEditPermission',
          'hasCreatePermission'
        ])}
        title={<CategoryTermTitle />}
        classes={{ noActions: classes.noActions }}
      >
        <CustomSimpleForm
          variant="standard"
          margin="normal"
          toolbar={
            <CreateToolbar allowNavigationOnSave={allowNavigationOnSave} />
          }
        >
          <FormSpy
            subscription={{ dirty: true }}
            onChange={props => {
              setTimeout(() => handleFormIsDirty(props.dirty), 1);
            }}
          />
          <CategoryTermsSummary creation={true} />
        </CustomSimpleForm>
      </Create>
    </React.Fragment>
  );
};

export default CategoryTermsCreate;
